import { useQuery } from '@tanstack/react-query';
import { type Profile, profileApi } from '@/api/admin/profiles';
import { Combobox } from '@/components/ui/combobox';

interface ProfileSelectorProps {
  profileId: string;
  onProfileChange: (profileId: string) => void;
}

export function ProfileSelector({ profileId, onProfileChange }: ProfileSelectorProps) {
  const { data: profilesData, isLoading: isLoadingProfiles } = useQuery({
    queryKey: ['profiles', { limit: 100 }],
    queryFn: () => profileApi.findMany({ limit: 100 }),
  });

  const { data: selectedProfile } = useQuery({
    queryKey: ['profile', profileId],
    queryFn: () => profileApi.findOne(profileId),
    enabled: !!profileId,
  });

  const handleProfileChange = (profiles: Profile[]) => {
    if (profiles.length > 0) {
      onProfileChange(profiles[0].id);
    } else {
      onProfileChange('');
    }
  };

  return (
    <div className="sm:w-96">
      <label htmlFor="profile" className="block text-sm/6 font-medium text-gray-900">
        Perfil
      </label>
      <div className="mt-2">
        <Combobox
          data={profilesData?.docs ?? []}
          displayValueGetter={(doc) => doc.name}
          keyExtractor={(doc) => doc.id}
          onOptionChange={handleProfileChange}
          type="single"
          defaultValue={selectedProfile ? [selectedProfile] : []}
          placeholder="Escolha uma opção"
          isLoading={isLoadingProfiles}
        />
      </div>
    </div>
  );
}
